import React from 'react'

import { useRemoteStrings, useAnalyticsClient } from '@acorns/web-utils'

import { StyledButton } from '../styled-components'

import { useReferralCode } from './useReferralCode'
import {
  trackRegistrationPromoCodeEnterCodeCtaTappedPayload,
  RegistrationPromoCodeEnterCodeCtaTappedState,
} from 'generated/trackingEvents'
import { translateEventProps } from 'utils/analytics'

interface Props {
  appliedPromoCode: string
  setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const PromoCodesCta = ({ appliedPromoCode, setIsDrawerOpen }: Props) => {
  const { hasReferralCode } = useReferralCode()
  const { getRemoteString } = useRemoteStrings()
  const analytics = useAnalyticsClient()

  const enterPromoCodeCta = getRemoteString({ key: 'create_account.promo_code_drawer.title' })

  const handleDrawerOpen = () => {
    setIsDrawerOpen(true)

    const [eventName, payLoad] = trackRegistrationPromoCodeEnterCodeCtaTappedPayload({
      promotion: appliedPromoCode,
      ctaTitle: enterPromoCodeCta,
      state: RegistrationPromoCodeEnterCodeCtaTappedState.Enter_new_code,
    })

    analytics.track(eventName, translateEventProps(payLoad))
  }

  if (hasReferralCode || appliedPromoCode?.length > 0) {
    return null
  }

  return <StyledButton onClick={handleDrawerOpen}>{enterPromoCodeCta}</StyledButton>
}
